<template lang="pug">
  .next-date-calendar.xs-12.text-center(:class="{ 'expanded': visible }")
    calendar.options-calendar.xs-f-small.sm-f-xsmall.max-at-tweak(@input="onDateSelect" :value="selectedDate" :min-date="minPostponeDate" :max-date="maxPostponeDate" :disabled-dates="invalidNextDates")
  
</template>

<script>
  import vueSubscriptionSvc from '../../../services/vueSubscriptionSvc';

  export default {
    name: "NextDateSelector",

    props: {
      subId: {
        type: Number,
        required: true
      },

      nextDate: {
        type: [Date, String],
        required: false
      },
      //- can use this to toggle visibility from outside
      toggle: {
        type: Boolean,
        required: false,
        default: true
      }
    },

    asyncComputed: {
      dateOptions() {
        return vueSubscriptionSvc.getSubDateOptions({
          sub_id: this.subId,
        }).then(res => res.data);
      }
    },

    methods: {
      onDateSelect(date) {
        this.selectedDate = date;
        this.$emit('onDateSelect', date);
      }
    },

    computed: {
      visible: {
        get() {
          return this.toggle;
        },

        set(val) {
          return val;
        }
      },

      selectedDate: {
        get() {
          return this.nextDate;
        },

        set(val) {
          return val;
        }
      },

      minPostponeDate() {
        return new Date();
      },

      maxPostponeDate() {
        if (!this.dateOptions || !this.dateOptions.maxSkipDays) {
          return null;
        }
        return new Date(new Date().setDate(this.minPostponeDate.getDate() + (this.dateOptions.maxSkipDays -1)));
      },

      invalidNextDates() {
        if (!this.dateOptions) {
          return [];
        }
        return this.dateOptions.closeDates;
      }
    }
   }
</script>

<style scoped lang="stylus">
  .next-date-calendar
    max-height 0
    transition(max-height 400ms ease-in-out)
    overflow hidden

    &.expanded
      max-height 38em

    .options-calendar
      margin 1.5em auto
</style>